import Vue from 'vue';
import Vuex from 'vuex';
import Service from '@/services/Service';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    session: { id: null, user: null },
    basket: { basketItemGroups: [], itemGroups: [] },
    messages: [],
    messageId: 0,
    showFilter: { searchText: '', genreId: null }
  },
  mutations: {
    SET_BASKET(state, basket) {
      state.basket = basket;
    },
    SET_SESSION(state, session) {
      state.session = session;
    },
    CLEAR_SESSION() {
      localStorage.removeItem('session');
      location.reload();
    },
    ADD_MESSAGE(state, message) {
      message.id = state.messageId++;
      state.messages.push(message);
    },
    DELETE_MESSAGE(state, id) {
      for (var i = 0, len = state.messages.length; i < len; i++) {
        if (state.messages[i].id === id) {
          return state.messages.splice(i, 1);
        }
      }
    },
    SET_FILTER(state, showFilter) {
      //important not to just assign the new object, as anything watching this object will lose reactivity
      state.showFilter = Object.assign({}, showFilter);
    }
  },
  actions: {
    addMessage({ commit }, message) {
      commit('ADD_MESSAGE', message);
      if (message.timeout && message.timeout > 0) {
        setTimeout(() => {
          commit('DELETE_MESSAGE', message.id);
        }, message.timeout);
      }
    },
    deleteMessage({ commit }, id) {
      commit('DELETE_MESSAGE', id);
    },
    loadBasket({ commit }) {
      if (this.state.session.id != null) {
        return Service.getBasket().then(response => {
          if (response.data != null) {
            commit('SET_BASKET', response.data);
          }
        });
      }
    },
    ensureSession({ commit }) {
      if (this.state.session.id == null) {
        return Service.createAnonymousSession().then(response => {
          commit('SET_SESSION', response.data);
          Service.setAuthHeader(response.data);
        });
      } else {
        return Service.setAuthHeader(this.state.session);
      }
    },
    login({ commit }, sessionId) {
      commit('SET_SESSION', sessionId);
      Service.setAuthHeader(sessionId);
    },
    logout({ commit }) {
      Service.setAuthHeader(null);
      commit('CLEAR_SESSION');
    },
    setFilter({ commit }, showFilter) {
      commit('SET_FILTER', showFilter);
    }
  },
  getters: {
    loggedIn(state) {
      return !!(state.session != null ? state.session.user : false);
    }
  }
});
